import type WPAPI from 'wpapi'

export function getQuiz (wpapi: WPAPI, quizId: string): any {
  wpapi.getQuizDatas = wpapi.registerRoute('cosa', '/quiz/(?P<id>\\d+)')
  return wpapi.getQuizDatas().id(quizId)
}

const ENDPOINT = window.location.origin + '/wp-json'

export async function postQuizResult (
  quizId: string,
  results: unknown,
  timer: unknown
): Promise<any> {
  
  const reponse = await fetch(`${ENDPOINT}/cosa/quiz/results/`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      quiz_id: quizId,
      results,
      timer
    })
  })
  const data = await reponse.json()
  return data
}

export async function getQuizResult (quizId: string): Promise<any> {
  const reponse = await fetch(`${ENDPOINT}/cosa/quiz/results/${quizId}`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET'
  })
  const data = await reponse.json()
  return data
}
